import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LoginPageOpened } from 'src/modules/security/actions/auth-actions';
import { SetSidebarPinned, SetSidebarWidth } from './sidebar-preferences.actions';

export interface SidebarPreferencesStateModel {
  widthRem: number | null;
  isPinned: boolean | null;
}

@State<SidebarPreferencesStateModel>({
  name: 'sidebarPreferences',
  defaults: { widthRem: null, isPinned: true }
})
@Injectable()
export class SidebarPreferencesState {
  @Selector()
  public static widthRem(state: SidebarPreferencesStateModel): number | null {
    return state.widthRem;
  }

  @Selector()
  public static isPinned(state: SidebarPreferencesStateModel): boolean | null {
    return state.isPinned;
  }

  @Action(SetSidebarWidth)
  public setWidth(ctx: StateContext<SidebarPreferencesStateModel>, { widthRem }: SetSidebarWidth): void {
    ctx.patchState({ widthRem });
  }

  @Action(SetSidebarPinned)
  public setPinned(ctx: StateContext<SidebarPreferencesStateModel>, { isPinned }: SetSidebarPinned): void {
    ctx.patchState({ isPinned });
  }

  @Action(LoginPageOpened)
  public clearPreferences(ctx: StateContext<SidebarPreferencesStateModel>): void {
    ctx.setState({ widthRem: null, isPinned: true });
  }
}
